var _desc, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonFileGiveHand3StreamlineUltimate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Common-File-Give-Hand-3--Streamline-Ultimate",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Common File Give Hand 3 Streamline Icon: https://streamlinehq.com\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0F2651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 12V2.25c0 -0.39782 0.15804 -0.77936 0.43934 -1.06066C7.47064 0.908035 7.85218 0.75 8.25 0.75h10.629c0.3975 0.000085 0.7788 0.157982 1.06 0.439l2.872 2.872c0.281 0.2812 0.4389 0.66245 0.439 1.06V18.75",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0F2651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.75 14.25h3c0.39782 0 0.77936 0.158 1.06066 0.4393 0.2813 0.2813 0.43934 0.6629 0.43934 1.0607v6c0 0.3978 -0.15804 0.7794 -0.43934 1.0607S4.14782 23.25 3.75 23.25h-3",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0F2651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.25 21.75c0 -0.7956 -0.3161 -1.5587 -0.8787 -2.1213 -0.5626 -0.5626 -1.3257 -0.8787 -2.1213 -0.8787H13.5c0 -0.7956 -0.3161 -1.5587 -0.8787 -2.1213 -0.5626 -0.5626 -1.3257 -0.8787 -2.1213 -0.8787H5.25v6h15Z",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0F2651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 18.75h3",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0F2651",
    d: "M2.625 20.25c-0.20711 0 -0.375 -0.1679 -0.375 -0.375s0.16789 -0.375 0.375 -0.375",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0F2651",
    d: "M2.625 20.25c0.20711 0 0.375 -0.1679 0.375 -0.375s-0.16789 -0.375 -0.375 -0.375",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonFileGiveHand3StreamlineUltimate);
export default __webpack_public_path__ + "static/media/Common-File-Give-Hand-3--Streamline-Ultimate.afeb2896ba84005a21e9f437fd2fa029.svg";
export { ForwardRef as ReactComponent };